<template>
  <div>
    <input :class="{ invalid: props.invalid }" type="text" :placeholder="$t('bet-slip.amount')" v-model="props.amount" />
  </div>
</template>

<script>
export default {
  props: {
    single: Boolean,
    type: {
      validator: function (value) {
        return [ 'POSITION', 'OPTION', 'SINGLES' ].indexOf(value) !== -1
      }
    },
    target: [ String, Number ],

    invalid: Boolean,
    amount: Number
  },
  data () {
    return {
      props: {
        invalid: this.invalid,
        amount: this.amount > 0 ? this.amount : ''
      }
    }
  },
  mounted () {
    if (this.single) {
      this.$store.watch(state => state.betSlip.singleStake,
        value => {
          this.props.amount = value > 0 ? value : ''
        }, { deep: true })
    }
    if (this.props.amount) {
      this.props.invalid = this.props.amount.length > 0 && (isNaN(this.props.amount) || !isFinite(this.props.amount))
      this.$store.commit('betSlip/SET_' + this.type + '_AMOUNT', {
        target: this.target,
        invalid: this.props.invalid,
        amount: this.props.amount
      })
      this.$store.commit('betSlip/CALCULATE_AMOUNTS')
      this.$store.commit('betSlip/CALCULATE_PLACEABLE')
    }
  },
  watch: {
    async 'props.amount' (value) {
      if (value.length) {
        value = value
          .split(',').join('.')
          .split(' ').join('')
      }
      this.props.invalid = value.length > 0 && (isNaN(value) || !isFinite(value))
      this.$store.commit('betSlip/SET_' + this.type + '_AMOUNT', {
        target: this.target,
        invalid: this.props.invalid,
        amount: this.props.amount
      })
      this.$store.commit('betSlip/CALCULATE_AMOUNTS')
      this.$store.commit('betSlip/CALCULATE_PLACEABLE')
    }
  }
}
</script>

<style scoped>
input { border: none; border-radius: 5px; text-align: right; width: 100px; }
input.invalid { background: #f44336; color: white;  }
input:focus::-webkit-input-placeholder { color: transparent; border: none; }
input:focus::-moz-placeholder { color: transparent; border: none; }
input:focus:-moz-placeholder { color: transparent; border: none; }
input:focus:-ms-input-placeholder { color: transparent; border: none; }
input::-webkit-input-placeholder { color: #231e4a; opacity: 1; }
input::-moz-placeholder { color: #231e4a; opacity: 1; }
input:-ms-input-placeholder { color: #231e4a; opacity: 1; }
input:-moz-placeholder { color: #231e4a; opacity: 1; }
</style>



// WEBPACK FOOTER //
// src/components/bet-slip/BetSlipAmount.vue